import { escape } from "lodash";

/**
 * Text for an HTML string (chart tooltips build theirs as HTML): `&`, `<`,
 * `>`, `"` and `'` escaped, so data such as a user-chosen account name can't
 * add markup. Nothing (null / undefined) is an empty string.
 */
export const escapeHtml = (value: unknown) =>
  value === null || value === undefined ? "" : escape(String(value));

const SAFE_COLOR_PATTERNS = [
  /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i,
  /^(?:rgba?|hsla?)\((?:[\d.\s%,/+-]|deg)*\)$/i,
  /^var\(--[\w-]+\)$/,
];

/**
 * A colour for an inline style in an HTML string: hex, rgb(a), hsl(a) or a
 * CSS variable; anything else (a gradient object, text that could close the
 * attribute) gives the fallback.
 */
export const safeCssColor = (color: unknown, fallback = "transparent") => {
  if (typeof color !== "string") return fallback;
  const trimmed = color.trim();
  return SAFE_COLOR_PATTERNS.some((pattern) => pattern.test(trimmed))
    ? trimmed
    : fallback;
};
